import queryString from 'query-string';

const parseQueryString = query => {
  return queryString.parse(query, { arrayFormat: 'comma' });
};

export default parseQueryString;
